import React from 'react';
import { UserOutlined, SettingOutlined, BugOutlined, StarOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Layout, Menu, theme } from 'antd';
import ContentRouter from './router';
import { useNavigate } from 'react-router';

const { Content, Footer, Sider } = Layout;

const siderStyle: React.CSSProperties = {
  overflow: 'auto',
  height: '100vh',
  position: 'sticky',
  insetInlineStart: 0,
  top: 0,
  bottom: 0,
};

const MenuConfig: MenuProps['items'] = [
  {
    key: `user`,
    icon: React.createElement(UserOutlined),
    label: `玩家`,
    children: [
      {
        key: 'user/user_management',
        label: `封禁/信誉分调整`,
      },
      {
        key: 'user/user_cheat_ban',
        label: `批量封号`,
      },
      {
        key: 'user/user_cheat_ban_table',
        label: `批量分布计算`,
      },
      {
        key: 'user/user_info',
        label: `信息查询`,
      },
      {
        key: 'user/ladder_limit',
        label: `天梯封禁`,
      },
      {
        key: 'user/sensitive_risk',
        label: `风控发言查询`,
      },
    ],
  },
  {
    key: `cheat`,
    icon: React.createElement(BugOutlined),
    label: `作弊`,
    children: [
      {
        key: 'cheat/process_data',
        label: `可疑进程查询`,
      },
      {
        key: 'cheat/suspicious_info',
        label: `可疑信息查询`,
      },
      {
        key: 'cheat/user_teammate_count',
        label: `组队队友查询`,
      },
      {
        key: 'auto_ban/auto_ban_status',
        label: `自动封号面板`,
      },
      {
        key: 'auto_ban/user_list_by_uuid',
        label: `UUID 反查用户`,
      },
    ],
  },
  {
    key: `replay`,
    icon: React.createElement(StarOutlined),
    label: `录像`,
    children: [
      {
        key: 'replay/collect',
        label: `收藏管理`,
      },
      {
        key: 'replay/game_name_lookup',
        label: `GameName 转换`,
      },
    ],
  },
  {
    key: `system`,
    icon: React.createElement(SettingOutlined),
    label: `系统`,
    children: [
      {
        key: 'system/update_token',
        label: `Token 更新`,
      },
      {
        key: 'system/gray_config',
        label: `配置查看`,
      },
      {
        key: 'system/mpq',
        label: `MPQ 管理`,
      },
      {
        key: 'system/update',
        label: `更新管理`,
      },
    ],
  },
];

const App: React.FC = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const navigate = useNavigate();

  return (
    <Layout hasSider>
      <Sider theme="light" style={siderStyle}>
        <div className="demo-logo-vertical" />
        <Menu
          mode="inline"
          style={{ height: '100%', borderInlineEnd: 0 }}
          items={MenuConfig}
          onClick={(item) => {
            navigate(item.key);
          }}
        />
      </Sider>
      <Layout>
        <Content style={{ margin: '24px 16px 24px', overflow: 'initial' }}>
          <div
            style={{
              padding: 24,
              textAlign: 'center',
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
            }}
          >
            <ContentRouter />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
